module.exports = __webpack_public_path__ + "static/media/reset-password.59d38ee6.svg";